const VerticalType = {
  event: "event",
  product: "product",
  booking: "booking"
};
const VERTICAL_PATHS = {
  product: "products",
  event: "events",
  booking: "bookings"
};
export {
  VERTICAL_PATHS,
  VerticalType
};
//# sourceMappingURL=consts.js.map
